'use client'

import { useTranslations } from 'next-intl'

import { Button } from '@graftcode/design-system'

import { NOTIFICATION_DRAWER_TEST_IDS } from '@common/common-test-ids.const'

import { NOTIFICATION_DRAWER_FILTER } from '../../notification-drawer.const'
import type { NotificationDrawerFilter } from '../../notification-drawer.type'

import styles from './NotificationDrawerFilters.module.scss'

type Props = {
  filter: NotificationDrawerFilter
  unreadCount: number
  onFilterChange: (filter: NotificationDrawerFilter) => void
  onMarkAllAsRead: () => void
}

export function NotificationDrawerFilters({ filter, unreadCount, onFilterChange, onMarkAllAsRead }: Props) {
  const t = useTranslations('notifications')

  return (
    <div className={styles.filters} data-testid={NOTIFICATION_DRAWER_TEST_IDS.filters}>
      <div className={styles.chips} role="tablist" aria-label={t('a11y.filters')}>
        <button
          type="button"
          role="tab"
          className={`${styles.filter} ${filter === NOTIFICATION_DRAWER_FILTER.ALL ? styles.filterActive : ''}`}
          aria-selected={filter === NOTIFICATION_DRAWER_FILTER.ALL}
          onClick={() => onFilterChange(NOTIFICATION_DRAWER_FILTER.ALL)}
        >
          {t('filters.all')}
        </button>
        <button
          type="button"
          role="tab"
          className={`${styles.filter} ${filter === NOTIFICATION_DRAWER_FILTER.UNREAD ? styles.filterActive : ''}`}
          aria-selected={filter === NOTIFICATION_DRAWER_FILTER.UNREAD}
          onClick={() => onFilterChange(NOTIFICATION_DRAWER_FILTER.UNREAD)}
        >
          {t('filters.unread', { count: unreadCount })}
        </button>
      </div>

      <Button size="m" variant="ghost" className={styles.markAllButton} onClick={onMarkAllAsRead}>
        {t('markAllAsRead')}
      </Button>
    </div>
  )
}
